import { defineStore } from 'pinia'
import { ElMessage } from 'element-plus'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    unlocked: false
  }),
  actions: {
    // 仅负责解锁状态，主题本身由 useTheme 组合式函数管理
    initUnlock() {
      // 恢复解锁状态
      if (typeof window !== 'undefined') {
        const unlockedFlag = window.localStorage.getItem('theme-switch-unlocked')
        this.unlocked = unlockedFlag === '1'
      }
    },
    unlock() {
      this.unlocked = true
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('theme-switch-unlocked', '1')
      }
    }
  }
})

